import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';
import { BasicLoader } from 'components/loaders/basic-loader';
import { AppContext } from 'core/context/app.context';
import { usePlatform } from 'core/hooks/platform';
import { _noop } from 'utils/function.utils';
import { ProfileStore } from '../profile.store';
import styles from './profile-card.module.scss';

export const ProfileCard = observer(
  ({
    theme = CardThemeType.DarkGlass,
    onClick = _noop,
  }: {
    theme?: CardThemeType;
    onClick?: (e: React.MouseEvent) => void;
  }) => {
    const { t } = useTranslation();
    const { platform } = usePlatform();
    const appContext = useContext(AppContext);
    const profileStore = useLocalObservable(() => new ProfileStore());

    useEffect(() => {
      profileStore.initialize(appContext.customerNumber, appContext.countryName, appContext.countryCode, platform);
    }, [appContext, profileStore]);

    const handleCopy = (e: React.MouseEvent) => {
      e.stopPropagation();
      navigator.clipboard.writeText(`${appContext.customerNumber}`);
    };

    return (
      <Card backgroundType={theme} onClick={onClick} classes={[`cust-mb-1`]} noMargin={true} mobilePadding={false}>
        <BasicLoader isLoading={profileStore.isLoading}>
          <div className={`text-lg-center ${styles.profileCard}`}>
            <div>
              <h5>
                {profileStore.user?.firstName} {profileStore.user?.surname}
              </h5>
            </div>
            <div className="text-small text-light-70 d-flex align-items-center justify-content-sm-center">
              <span>
                {`${t('common.customerNumber')} `}
                {appContext.customerNumber}
              </span>
              <span
                className={`cust-ml-1 icon-copy-clipboard cursor-pointer ${styles.copyIcon}`}
                onClick={(e) => handleCopy(e)}
              />
            </div>
          </div>
        </BasicLoader>
      </Card>
    );
  }
);